/**
 * Socket.IO factory for the `/voice` namespace. Mirrors the notifications
 * socket client: JWT in the handshake `auth.token`, websocket-only, auto
 * reconnection. The caller connects after attaching listeners.
 */
import { io, type Socket } from 'socket.io-client';

import { getAccessToken } from '@/api/token';

export type VoiceSocket = Socket;

const DEFAULT_BASE_URL = (import.meta.env.VITE_API_URL ?? 'http://localhost:3000') as string;

export function createVoiceSocket(): VoiceSocket {
    return io(`${DEFAULT_BASE_URL}/voice`, {
        autoConnect: false,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 500,
        reconnectionDelayMax: 5_000,
        timeout: 10_000,
        transports: ['websocket'],
        // Resolved per connection ATTEMPT, not captured once — a snapshot
        // token goes stale across backend restarts / JWT rotation and every
        // reconnect handshake would then fail forever.
        auth: (cb) => cb({ token: getAccessToken() }),
        withCredentials: true,
    });
}
